<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">
        Options
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label class="form-label">Origin Port</label>
              <autocomplete
                :dataset="ports"
                title="Origin Port"
                placeHolder="Type to search"
                :initVal="entity.originPort"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="selectOrigin"
              ></autocomplete>
            </div>
            <div class="form-group">
              <label class="form-label">Destination Port</label>
              <autocomplete
                :dataset="ports"
                title="Destination Port"
                placeHolder="Type to search"
                :initVal="entity.destinationPort"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="selectDestination"
              ></autocomplete>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label class="form-label">Consolidation Point</label>
              <autocomplete
                :dataset="locationSearchResults"
                title="Destination Port"
                placeHolder="Type to search"
                :initVal="entity.consolidationPoint"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="selectConP"
              ></autocomplete>
            </div>
            <div class="form-group">
              <label for="cp-ext" class="form-label">External ID *</label>
              <input type="text" class="form-control" id="cp-ext" v-model="entity.externalId"/>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  import HelperMixin from '../../mixins/Helpers'
  export default {
    name: 'ConsolidationPoint',
    mixins: [AdminEntityMixin, HelperMixin],
    data () {
      return {
        transformForUpdate: {
          originPort: this.toMinus,
          destinationPort: this.toMinus,
          consolidationPoint: this.toMinus,
          externalId: this.toZero
        },
        newEntityScreen: 'Admin - Consolidation Points',
        editEntityScreen: 'Admin - Edit/View Consolidation Point',
        tab: 'main',
        entity: {
          id: null,
          originPort: null,
          destinationPort: null,
          consolidationPoint: null,
          externalId: null
        },
        entityName: 'consolidation-point',
        boxes: []
      }
    },
    components: {
      Autocomplete
    },
    computed: {
      isValid () {
        return this.entity.originPort && this.entity.destinationPort && this.entity.consolidationPoint
      },
      ports () {
        return this.locationSearchResults.filter(({category}) => category === 'PORT')
      }
    },
    methods: {
      selectOrigin (o) {
        this.entity.originPort = o
        this.locationSearchText = ''
        this.locationSearchResults = []
      },
      selectDestination (d) {
        this.entity.destinationPort = d
        this.locationSearchText = ''
        this.locationSearchResults = []
      },
      selectConP (d) {
        this.entity.consolidationPoint = d
        this.locationSearchText = ''
        this.locationSearchResults = []
      },
      getBaseData () {
        return {
          id: null,
          originPort: null,
          destinationPort: null,
          consolidationPoint: null,
          externalId: null
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// ConsolidationPoint.vue?49d72832